import TickerElement from '../../components/ticker/ticker-element';
import PerformanceIndicator from '../../components/ticker/ticker-performance-indicator';
import TickerExtremes from '../../components/ticker/ticker-extremes';

const createTickerElement = (el) => {
	const { dataset, dataset: { tickerType } } = el;

	if (tickerType === 'extreme') {
		return new TickerExtremes(el, dataset);
	}

	if (tickerType === 'performance') {
		return new PerformanceIndicator(el, dataset);
	}

	return new TickerElement(el, dataset);
};

export default createTickerElement;
